import React from "react";
import { useSelector } from "react-redux";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = () => {
  const dateFormat = useDateFormat();

  const {
    date,
    currentUser: { calendarStartDate, calendarEndDate }
  } = useSelector((state) => state.riskMembers);

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      calendarEndDate={calendarEndDate}
      disabled
      minDate={calendarStartDate}
      startDate={date ? date : calendarEndDate}
    />
  );
};

export default DatePicker;
